import { render, staticRenderFns } from "./GroupMindInput.vue?vue&type=template&id=0f184f0f"
import script from "./GroupMindInput.vue?vue&type=script&lang=js"
export * from "./GroupMindInput.vue?vue&type=script&lang=js"
import style0 from "./GroupMindInput.vue?vue&type=style&index=0&id=0f184f0f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports